'use strict';

/* SmartTechSG hero slideshow
 * Single, smooth horizontal slide transition.
 * Keeps the existing autoplay, loop and pagination behavior.
 */
(function () {
  const TAG_NAME = 'slideshow-banner';
  const TRANSITION_DURATION = 700;

  if (!customElements.get(TAG_NAME)) {
    class SlideshowBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(true, true);
        }
        this.swiper = null;
      }

      initSwiper = () => {
        if (this.swiper && !this.swiper.destroyed) return;
        if (typeof window.Swiper === 'undefined') return;

        const wrapper = this.querySelector('.swiper-wrapper');
        const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
        const slideCount = slides.length;
        if (!slideCount) return;

        const autoplayEnabled = this.dataset.autoplay === 'true';
        const autoplaySeconds = Number(this.dataset.speed || 5);
        const loopEnabled = this.dataset.loop !== 'false' && slideCount > 1;
        const paginationElement = this.querySelector('.swiper-pagination');

        const options = {
          slidesPerView: 1,
          effect: 'slide',
          speed: TRANSITION_DURATION,
          loop: loopEnabled,
          watchOverflow: true,
          grabCursor: false,
          allowTouchMove: true,
          autoplay: autoplayEnabled ? {
            delay: Math.max(1, autoplaySeconds) * 1000,
            disableOnInteraction: false
          } : false,
          pagination: paginationElement ? {
            el: paginationElement,
            clickable: true,
            type: 'bullets'
          } : false
        };

        try {
          this.swiper = new window.Swiper(this, options);
        } catch (error) {
          this.swiper = null;
          console.error('[SmartTechSG] Slideshow initialization failed.', error);
        }
      };
    }

    customElements.define(TAG_NAME, SlideshowBanner);
  }

  // Reinitialize the hero when Shopify's theme editor reloads the section.
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target;
    if (!root) return;

    const banners = [];
    if (root.matches && root.matches(TAG_NAME)) banners.push(root);
    if (root.querySelectorAll) banners.push(...root.querySelectorAll(TAG_NAME));

    banners.forEach(function (banner) {
      if (banner.swiper && typeof banner.swiper.destroy === 'function') {
        banner.swiper.destroy(true, true);
        banner.swiper = null;
      }
      if (typeof banner.initSwiper === 'function') banner.initSwiper();
    });
  });
})();
